/**
 * 테넌트별 예산과목 시드 라우터
 */
import { ensureMofas2026Bootstrap, MOFAS_2026_SOURCE } from './mofas2026BudgetSubjects';
import {
  ensureGnkBudgetBootstrap,
  GNK_BUDGET_SUBJECT_SOURCE,
  isGnkTenant,
} from './gnkBudgetSubjects';

export { MOFAS_2026_SOURCE, GNK_BUDGET_SUBJECT_SOURCE };

/**
 * @param {object} dims
 * @param {{ userId?: string }} [options]
 */
export function ensureBudgetSubjectBootstrap(dims, options = {}) {
  if (isGnkTenant(dims?.tenantCode) && dims?.inoutDiv === '지출') {
    return ensureGnkBudgetBootstrap(dims, options);
  }
  return ensureMofas2026Bootstrap(dims, options);
}
